<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/cityWaterUse.js'
	import '../../static/js/provinceWaterUse.js'
	export default {
		name: 'mapuse',
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityWaterUse,
				provicesD:provinceWaterUse,
				unit:'升',
				mapName:'城市人均日生活用水量',
				mapTitle:'2018年城市人均日生活用水量地图(升)',
				mapColor:['#fff','#B6EDF0', '#81C0EB', '#4695E3', '#216BD1', '#1C3AB0', '#0A0A91'],
				pieces:[
							{
								min: 261.342433
							}, 
							{
								min: 208.007031,
								max:261.342432
							},
							{
								min: 167.353046,
								max: 208.007030
							},
							{
								min: 132.439023,
								max: 167.353045
							},
							{
								min: 98.263977,
								max: 132.439022
							},
							{
								min: 54.648153,
								max: 98.263976
							},
							{
								min: 0,
								max: 54.648152
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
